import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { results, firmInfo } from '../data/mockData';
import { TrendingUp, Award, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const ResultsPage = () => {
  const additionalResults = [
    { category: 'Motorcycle Accident', amount: '$2.8M' },
    { category: 'Slip & Fall', amount: '$1.9M' },
    { category: 'Nursing Home Negligence', amount: '$2.4M' },
    { category: 'Drunk Driver', amount: '$3.1M' },
    { category: 'Spinal Injury', amount: '$4.2M' },
    { category: 'Pedestrian Accident', amount: '$1.7M' },
  ];

  const allResults = [...results, ...additionalResults.map((r, i) => ({ ...r, id: results.length + i + 1, link: '/case-types' }))];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-50 via-white to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Our <span className="text-blue-900">Results</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              A proven track record of success for our clients
            </p>
          </div>

          {/* Featured Result */}
          <div className="bg-blue-900 rounded-2xl p-8 md:p-12 text-center mb-12 shadow-xl">
            <Award className="w-16 h-16 text-amber-400 mx-auto mb-4" />
            <div className="text-5xl md:text-7xl font-bold text-white mb-4">
              {firmInfo.largestSettlement}
            </div>
            <p className="text-xl text-white font-semibold mb-2">
              {firmInfo.settlementTitle}
            </p>
            <p className="text-blue-200">Head & Brain Injury Case</p>
          </div>
        </div>
      </section>

      {/* Results Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {allResults.map((result) => (
              <Link
                key={result.id}
                to={result.link || '/case-types'}
                className="group bg-white rounded-xl p-6 border border-gray-200 hover:border-blue-300 transition-all duration-300 shadow-md hover:shadow-lg"
              >
                {/* Amount */}
                <div className="mb-4">
                  <div className="flex items-center gap-2 text-blue-900 mb-1">
                    <TrendingUp className="w-4 h-4" />
                  </div>
                  <span className="text-3xl md:text-4xl font-bold text-blue-900">
                    {result.amount}
                  </span>
                </div>

                {/* Category */}
                <h3 className="text-gray-700 text-sm font-medium leading-tight group-hover:text-blue-900 transition-colors">
                  {result.category}
                </h3>

                {/* Arrow on hover */}
                <div className="mt-4 flex items-center text-blue-900 text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                  View Case <ArrowRight className="w-4 h-4 ml-2" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-900">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">Let Us Fight For Your Results</h2>
          <p className="text-blue-200 mb-8">Every case is unique. Contact us to discuss your situation.</p>
          <Button
            asChild
            size="lg"
            className="bg-white hover:bg-gray-100 text-blue-900 font-bold px-8 py-6 text-lg rounded-md"
          >
            <Link to="/contact">Get Free Consultation</Link>
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ResultsPage;
